// Standard FHIR R4 IANA timezone extension. Sites are written with the
// registered `tz-code` extension only (the site editor stamps this URL and
// strips the old `location-timezone` on save), so readers resolve timezone
// from tz-code alone. The legacy URL is retained here only so the site editor
// can strip it on write.
export const TZ_CODE_EXT = "http://hl7.org/fhir/StructureDefinition/tz-code";
export const LEGACY_LOCATION_TIMEZONE_EXT =
  "http://hl7.org/fhir/StructureDefinition/location-timezone";

// Returns a Location's IANA timezone (valueCode) or "" if the tz-code
// extension is not present.
export const getLocationTimezone = (location) => {
  const exts = location?.extension || [];
  return exts.find((e) => e.url === TZ_CODE_EXT)?.valueCode || "";
};
